export default __webpack_public_path__ + "static/media/Design.ad854b86.svg";